import React from 'react';
import FeatherIcon from 'feather-icons-react';
import {
  CityIcon,
  CounterIcon,
  HomeIcon,
  PlanIcon,
  ServiceIcon,
  SettingIcon,
  SoftwareComponentIcon,
  StationIcon,
  TemplateIcon,
} from '@/assets/icons/entities/_';
import { MenuGroupProps } from '../__base';
import { GlobalPermissionConfig, GlobalUrl } from '@/routers/globalRouters';

export const ConfigurationMenu: MenuGroupProps[] = [
  {
    groupName: 'menu.MainMenu',
    items: [
      {
        icon: <HomeIcon />,
        title: 'menu.Dashboard',
        key: 'dashboard',
        to: GlobalUrl.Configurations.Dashboard,
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Configurations.Dashboard),
      },
    ],
  },

  {
    groupName: 'menu.SystemSettings',
    items: [
      {
        icon: <CounterIcon />,
        title: 'menu.Registers',
        key: 'registers',
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Configurations.Registers),
        to: GlobalUrl.Configurations.Registers,
      },
      {
        icon: <ServiceIcon />,
        title: 'menu.Services',
        key: 'services',
        to: GlobalUrl.Configurations.Services,
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Configurations.Services),
      },
      {
        icon: <PlanIcon />,
        title: 'menu.Plans',
        key: 'plans',
        to: GlobalUrl.Configurations.Plans,
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Configurations.Plans),
      },
      {
        icon: <SoftwareComponentIcon />,
        title: 'menu.SoftwareComponents',
        key: 'software-components',
        to: GlobalUrl.Configurations.SoftwareComponents,
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Configurations.SoftwareComponents),
      },
      {
        icon: <StationIcon />,
        title: 'menu.Stations',
        key: 'stations',
        to: GlobalUrl.Configurations.Stations,
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Configurations.Stations),
      },
      {
        icon: <SettingIcon />,
        title: 'menu.CommonSetting',
        key: 'global-settings',
        to: GlobalUrl.Configurations.GlobalSettings,
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Configurations.GlobalSettings),
      },
      {
        icon: <CityIcon />,
        title: 'menu.CountryRegionCity',
        key: 'country-city-region',
        permissions: [
          ...GlobalPermissionConfig.__getPermission(GlobalUrl.Configurations.Countries),
          ...GlobalPermissionConfig.__getPermission(GlobalUrl.Configurations.Regions),
          ...GlobalPermissionConfig.__getPermission(GlobalUrl.Configurations.Cities),
        ],

        subMenu: [
          {
            title: 'menu.Countries',
            key: 'countries',
            to: GlobalUrl.Configurations.Countries,
            permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Configurations.Countries),
          },
          {
            title: 'menu.Regions',
            key: 'regions',
            to: GlobalUrl.Configurations.Regions,
            permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Configurations.Regions),
          },

          {
            title: 'menu.Cities',
            key: 'cities',
            to: GlobalUrl.Configurations.Cities,
            permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Configurations.Cities),
          },
        ],
      },

      {
        icon: <TemplateIcon />,
        title: 'menu.Templates',
        key: 'manage-templates',
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Configurations.ManageTemplates),
        to: GlobalUrl.Configurations.ManageTemplates,
      },
    ],
  },
];
